import { Box, Container, Heading, Icons, Inline } from "@sembark-travel/ui-base"
import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { EditPaymentPolicy, TPaymentPolicyDetail } from "../../../PaymentPolicy"
import { useNavigate, useParams, useSearchParams } from "../../../router-utils"
import { isTruthy } from "@sembark-travel/ui-form"

export default function EditPaymentPolicyPage() {
	const { paymentPolicyId } = useParams("/payment-policy/:paymentPolicyId/edit")
	const detailId = Number(paymentPolicyId)
	const navigate = useNavigate()
	const [query] = useSearchParams()

	const versionId = Number(query.get("version_id")) || undefined
	const version = Number(query.get("version")) || undefined
	const detailName = query.get("name") || "Payment Policy"
	const isDefault = isTruthy(query.get("is_default"))

	function goToItem(updatedDetail?: TPaymentPolicyDetail) {
		const params = new URLSearchParams(
			updatedDetail?.latest_policy
				? {
						name: updatedDetail.name,
						is_default: String(Boolean(updatedDetail.is_default)),
						version_id: String(updatedDetail.latest_policy.id),
						version: String(updatedDetail.latest_policy.version),
					}
				: {
						name: detailName,
						is_default: String(isDefault),
						...(versionId ? { version_id: String(versionId) } : {}),
						...(version ? { version: String(version) } : {}),
					}
		)
		navigate(
			{
				pathname: "/payment-policy/:paymentPolicyId",
				search: params.toString(),
			},
			{ params: { paymentPolicyId }, replace: true }
		)
	}

	return (
		<>
			<Helmet>
				<title>Edit Payment Policy</title>
			</Helmet>
			<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
				<Box paddingY="4" borderBottomWidth="1">
					<Container>
						<Inline gap="4" alignItems="center">
							<Box
								cursor="pointer"
								onClick={() => navigate(-1)}
								title="Go back"
							>
								<Icons.ArrowLeft size="5" />
							</Box>
							<Heading as="h4">Edit Payment Policy</Heading>
						</Inline>
					</Container>
				</Box>
				<Container paddingY="6">
					{versionId ? (
						<EditPaymentPolicy
							detailId={detailId}
							versionId={versionId}
							detailName={detailName}
							onSuccess={goToItem}
							onCancel={() => goToItem()}
							isDefault={isDefault}
						/>
					) : null}
				</Container>
			</ForbidUnlessAuthorized>
		</>
	)
}
